
    <!--
 * 竖版-签到领奖
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_2DMU62"  :class="[`normal`,`u_c_2DMU62`]" ><div id="u_c_5V8763"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_5V8763`]" ></div><div id="u_c_5W8Y64"  v-html="compData.subTitle" :class="[`normal`,`u_c_5W8Y64`]" ></div><div id="u_c_96AS65"  :class="[`normal`,`u_c_96AS65`]" ><span id="u_c_DXD666"  :class="[`normal txt`,`u_c_DXD666`]" >{{`${ langData.mySignTime }:`}}</span><span id="u_c_09RI68"  :class="[`normal txt`,`u_c_09RI68`]" >{{`${ pageData.signTime }`}}</span><span id="u_c_DBKV70"  :class="[`normal txt`,`u_c_DBKV70`]" >{{`${ langData.day }`}}</span></div><div id="u_c_CZVX72"  :class="[`normal`,`u_c_CZVX72`]" ><div id="u_c_7WB473"  v-for="(signItem, signIndex) in compData.signInfo" :key="signIndex" :data-index="signItem.day" :class="[`normal sign-item btn-light`,`u_c_7WB473`]" @click="u_c_7WB473_event_W81W61($event,signIndex)"><div id="u_c_5GV674"  :class="[`normal`,`u_c_5GV674`]" >{{`${ signItem.day }${ langData.day }`}}</div><div id="u_c_5L0X76"  :style="`background-image:url(${ signItem.pic })`" :class="[`u_c_5L0X76_${signIndex}`,`normal sign-img`,`u_c_5L0X76`]" ></div><div id="u_c_GHVC77"  v-show="signItem.state == 2 || signItem.state == void 0 && signIndex == 0" :class="[`normal`,`u_c_GHVC77`]" ></div></div></div><a id="u_c_87RF78" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light `,`u_c_87RF78`]" @click="u_c_87RF78_event_8J5W26($event)"><div id="u_c_EUFQ79"  :class="[`normal page-common-btn`,`u_c_EUFQ79`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"signInfo":[{"name":"签到第1个奖励\n签到第1-1个奖励\n签到第1-2个奖励\n签到第1-3个奖励","day":"1","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607104.png"},{"name":"签到第2个奖励","day":"2","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960122.png"},{"name":"签到第3个奖励","day":"3","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189607890.png"},{"name":"签到第4个奖励","day":"4","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609844.png"},{"name":"签到第5个奖励","day":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189609538.png"},{"name":"签到第6个奖励","day":"6","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/1675418960221.png"},{"name":"签到第7个奖励","day":"7","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/02/16754189606833.png"}],"subTitle":`累计签到达到以下次数，可领取活动奖励`,"title":`九考特训
签到送好礼`},"zh-TW":{"signInfo":[{"name":"元寶*50\n白銀沙漏*5\n急速行軍*5","day":"1","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241597545761265.png"},{"name":"高級輜重箱*2\n黃金沙漏*2\n黃金募令*5","day":"3","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241598816683968.png"},{"name":"兵種技錦囊*10\n黃金沙漏*5\n點將令*10","day":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241598853515320.png"},{"name":"元寶*200\n兵法集錄*10\n點將令*10","day":"7","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172241598876016176.png"}],"subTitle":`活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；`,"title":`每日簽到送不停`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform

const init = () => {
  compData.signInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.signList) {
      let confList = _.cloneDeep(compData.signInfo)
      compData.signInfo = []
      value.signList.forEach((item, index) => {
        if (confList[index]) {
          compData.signInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            day: item.sign_day,
            name: confList[index].name
          })
        }
      })
      giftInfo.signInAward = compData.signInfo
    }
  }, {
    deep: true
  }
)

init()

const canClickSign = ref(true)
const signDay = async (day, index) => {

  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'signInAward'), {
    params: JSON.stringify({
      sign_day: +day,
      language: curLang
    }),
  })
  if (res.result == 1) {
    compData.signInfo[index].state = 2;
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value : compData.signInfo[index].name;
    showGetSucc(res.data.send_type, compData.signInfo[index].pic, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 签到item的click事件
      const u_c_7WB473_event_W81W61= async (e,index)=>{
        try {pageData.seeGift = [compData.signInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 签到可领按钮的click事件
      const u_c_87RF78_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickSign.value) return;
canClickSign.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: `领取签到奖励`,
  gameId: pageData.gameId,
  aid: pageData.pageId
});
let curIndex = compData.signInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await signDay(compData.signInfo[curIndex].day, curIndex);
} else {
  let finishIndex = compData.signInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.signInfo.length - 1 ? '-20001' : '-10010',
      getLangTxt('common')
    ),
    ''
  );
}
canClickSign.value = true;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208087-83.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.default{
.u_c_DXD666.normal{
position:relative;

}
}.default{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.default{
.u_c_DBKV70.normal{
position:relative;

}
}.default{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.default{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208260-2.png);
background-size:contain;
width:2.81rem;
height:3.04rem;

}
}.default{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#fffafa;
text-align:center;
margin:auto;
margin-top:0.31rem;

}
}.default{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.default{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.default{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.36rem;
height:2.77rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.85rem;
font-weight:bold;

}
}.zh-TW{
.u_c_2DMU62.normal{
position:relative;
width:10.00rem;
height:19.41rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208087-83.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_5V8763.normal{
position:relative;
width:10.31rem;
height:2.48rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.65rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_5V8763.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_5W8Y64.normal{
position:relative;
margin-top:0.43rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_96AS65.normal{
position:relative;
text-align:center;
margin-top:0.40rem;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_96AS65.normal .txt{
color:#ffffff;
font-size:0.29rem;

}
}.zh-TW{
.u_c_DXD666.normal{
position:relative;

}
}.zh-TW{
.u_c_09RI68.normal{
position:relative;
margin:auto 0.27rem;

}
}.zh-TW{
.u_c_DBKV70.normal{
position:relative;

}
}.zh-TW{
.u_c_CZVX72.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.53rem;
text-align:center;

}

.u_c_CZVX72.normal .sign-item{
display:inline-block;
margin:auto 0.13rem 0.33rem;

}

.u_c_CZVX72.normal .sign-img{
max-width:90%;

}
}.zh-TW{
.u_c_7WB473.normal{
position:relative;
text-align:center;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208260-2.png);
background-size:contain;
width:2.81rem;
height:3.04rem;

}
}.zh-TW{
.u_c_5GV674.normal{
position:relative;
font-size:0.29rem;
color:#fffafa;
text-align:center;
margin:auto;
margin-top:0.31rem;

}
}.zh-TW{
.u_c_5L0X76.normal{
position:relative;
width:2.53rem;
height:1.56rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.37rem;

}

.u_c_5L0X76.u_c_5L0X76_0{
width:2.09rem;
height:1.31rem;
margin-top:0.39rem;

}

.u_c_5L0X76.u_c_5L0X76_1{
width:2.01rem;
height:1.68rem;
margin-top:0.31rem;

}

.u_c_5L0X76.u_c_5L0X76_2{
width:2.17rem;
height:1.21rem;
margin-top:0.51rem;

}

.u_c_5L0X76.u_c_5L0X76_3{
width:2.01rem;
height:1.49rem;
margin-top:0.40rem;

}

.u_c_5L0X76.u_c_5L0X76_4{
width:2.20rem;
height:1.07rem;
margin-top:0.59rem;

}

.u_c_5L0X76.u_c_5L0X76_5{
width:2.32rem;
height:1.24rem;
margin-top:0.47rem;

}

.u_c_5L0X76.u_c_5L0X76_6{
width:2.08rem;
height:1.32rem;
margin-top:0.43rem;

}
}.zh-TW{
.u_c_GHVC77.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:1.33rem;
right:1.03rem;

}
}.zh-TW{
.u_c_87RF78.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.36rem;
height:2.77rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_EUFQ79.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.85rem;
font-weight:bold;

}
}
</style>
